export const CARD_CLASS_NAMES = {
  card: 'bg-primary-highlight text-white border-1',
  cardHeader: 'bg-primary text-white',
  cardBody: 'bg-base rounded-2',
  field: 'bg-primary text-white border-0',
};

export const REPORTING_MODES_OPTIONS = { 1: 'Auto', 2: 'Fast', 3: 'Slow' };
export const SAMPLING_MODES_OPTIONS = { 0: '30 seconds', 1: '60 seconds' };

export const IMAGING_MODES = [
  { displayName: 'Depth Detection Imaging', settingName: 'dDetImgEnable' },
  { displayName: 'Rise Rate Imaging', settingName: 'ffiImgEnable' },
  { displayName: 'Drop Rate Imaging', settingName: 'dRateImgEnable' },
  { displayName: 'High Resolution Imaging', settingName: 'hResImgEnable' },
];
